<!-- Need ghostElementPositioning to be 'absolute' (rather than 'fixed') as otherwise calculations for scrolling the window when resizing will be incorrect -->
<div [ngClass]="chartClass" mwlResizable [enableGhostResize]="true" [ghostElementPositioning]="'absolute'" [validateResize]="validateResize"
     (resizeStart)="onResizeStart($event)" (resizing)="onResize($event)" (resizeEnd)="onResizeEnd($event)">
  <div #chartContainer [style.height]="chartHeight"></div>
  @if (allowResize) {
    <div mwlResizeHandle class="resize-handle m-auto" [resizeEdges]="{ bottom: true }"></div>
  }
</div>

<ng-template #chartTypePrompt let-modal>
  <form #form="ngForm" (ngSubmit)="modal.close(chartTypeControl.value)">
      <div class="modal-body">
          <div class="form-group">
            <label for="chart-type" class="form-label">{{ 'Select Chart Type' | messageTranslate }}</label>
            <app-ace-select
              id="chart-type"
              name="chart-type"
              required
              [items]="availableChartTypeOptions"
              [ngModel]="chartType"
              #chartTypeControl="ngModel"
              [bindLabel]="'label'"
              [bindValue]="'value'"
              [placeholder]="'Select Chart Type' | messageTranslate"/>
              <app-errors [control]="chartTypeControl"/>
          </div>
      </div>
      <div class="modal-footer">
          <button type="submit" class="btn btn-primary" [disabled]="!form.valid">{{ 'OK' | messageTranslate }}</button>
          <button type="button" class="btn btn-secondary" (click)="modal.dismiss('User cancel')">{{ 'Cancel' | messageTranslate }}</button>
      </div>
  </form>
</ng-template>

<ng-template #timezonePrompt let-modal>
  <form #form="ngForm" (ngSubmit)="modal.close(timezoneControl.value)">
    <div class="modal-body">
      <div class="form-group">
        <label for="timezone" class="form-label">{{ 'Select Timezone' | messageTranslate }}</label>
        <app-ace-select #timezoneControl="ngModel"
                        id="timezone"
                        name="timezone"
                        [items]="availableTimezones"
                        [ngModel]="timezone"
                        [bindLabel]="'label'"
                        [bindValue]="'value'"
                        [placeholder]="'Sites Timezone with timezone' | messageTranslate:{timezone: site?.timezone}"
                        [clearable]="true"/>
        <app-errors [control]="timezoneControl"/>
        @if (timezoneControl.value) {
          <small class="text-body-secondary">{{'Clear selected timezone value' | messageTranslate:{timezone: site?.timezone} }}</small>
        }
      </div>
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-primary" [disabled]="!form.valid">{{ 'OK' | messageTranslate }}</button>
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss('User cancel')">{{ 'Cancel' | messageTranslate }}</button>
    </div>
  </form>
</ng-template>
